export const TABLE_MAX_SIZE = 8;

export default TABLE_MAX_SIZE;